import {Injectable} from '@angular/core';
import {checkIfASCII, checkIfGiveCharIsNumberOrLetter} from './CommonFunctions';
import {FormGroup} from '@angular/forms';
import {ChangeVO} from '../generate/ChangeVO';
import {ErrorVO} from '../generate/ErrorVO';

@Injectable({
  providedIn: 'root'
})
export class UtilService {

  constructor() {
  }

  checkIfEmpty(value: string): boolean {
    if (this.checkNull(value)) {
      return true;
    }
    return '' === value.trim();
  }

  checkIfEmptyList(value: string[]): boolean {
    if (this.checkNull(value)) {
      return true;
    }
    return value.length == 0;
  }

  checkNull(value: any): boolean {
    return value == null;
  }


  checkIfGivenCharisNumberOrLetter(char: string): boolean {
    if (this.checkIfEmpty(char)) {
      return false;
    }

    return checkIfGiveCharIsNumberOrLetter(char);
  }


  isASCII(str): boolean {
    return checkIfASCII(str);
  }

  getDisplayValue(value: string): string {
    if (this.checkIfEmpty(value)) {
      return '';
    }

    return value.trim();
  }

  returnNullIfEmpty(value: string) {
    if (this.checkIfEmpty(value)) {
      return null;
    }

    return value.trim();
  }


  cloneArray(values: Array<any>): Array<any> {
    if (values == null) {
      values = [];
      return values;
    }
    return values.slice();

  }


  public defineCSS(operationType: string): string {
    if (operationType === 'NOOP') {
      return '';
    } else if (operationType === 'ADD') {
      return 'opp-added';
    } else if (operationType === 'UPDATE') {
      return 'opp-updated';
    } else if (operationType === 'REMOVE') {
      return 'opp-removed';
    }

    return '';
  }

  getChange(field: string, change: ChangeVO): ChangeVO {
    if (change == null) {
      return null;
    }
    for (const eachChange of change.changes) {
        if (eachChange.field === field) {
          return eachChange;
        }
    }

    return null;
  }

  getContactFieldChange(field: string, change: ChangeVO): ChangeVO {
    if (change == null) {
      return null;
    }

    for (const eachChange of change.changes) {
      if (field.indexOf('address-') > -1 && eachChange.field === 'address') {
        field = field.replace('address-', '');
        for (const addChange of eachChange.changes) {
          if (addChange.field === field) {
            return addChange;
          }
        }

      } else {
        if (eachChange.field === field) {
          return eachChange;
        }
      }
    }

    return null;
  }

  buildObjectFromChange(object: Array<any>, allChanges: ChangeVO) {
    for (const change of allChanges.changes) {
      if (change.operationType === 'NOOP') {
        object.push(change.oldVal);
      } else if (change.operationType === 'ADD') {
        object.push(change.newVal);
      } else if (change.operationType === 'UPDATE') {
        object.push(change.newVal);
      } else if (change.operationType === 'REMOVE') {
        object.push(change.oldVal);
      }
    }
  }

  public capatalizeFirstChar(val: string): string {
    if (this.checkIfEmpty(val)) {
      return '';
    }
    return val.charAt(0).toUpperCase() + val.slice(1);
  }

  displayValidationError(form: FormGroup, controlName: string) {
    return form.contains(controlName)
      && !form.get(controlName).valid
      && form.get(controlName).touched;
  }

  getFieldError(field: string, errors: ErrorVO): ErrorVO {
    if (errors != null && errors.errors != null) {
      for (const error of errors.errors) {
        if (field === error.field) {
          return error;
        }
      }
    }
    return null;
  }
}
